import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { erc20Abi, zeroAddress } from 'viem'
import { cleanAddress } from '../../addresses'
import { ERC20Token, PoolAddressMap } from '../../types'

/**
 * A map of paired token symbols to network and their respective Uniswap v3 pool addresses.
 */
const UNISWAP_POOLS = {
  ['WETH']: {
    [mainnet.id]: cleanAddress(zeroAddress),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xA0Ca5bEbC42cDbf3623B1C09206Ae4e3975B0FC7'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress(zeroAddress),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress(zeroAddress),
    [arbitrum.id]: cleanAddress(zeroAddress),
  },
  ['USDC']: {
    [mainnet.id]: cleanAddress(zeroAddress),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xedc625b74537ee3a10874f53d170e9c17a906b9c'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress(zeroAddress),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress(zeroAddress),
    [arbitrum.id]: cleanAddress(zeroAddress),
  },
} as const satisfies PoolAddressMap

/**
 * ZORA contract info
 *
 * Contains static token information, the ERC20 abi, a map contract addresses
 * by network and a map of relevant Uniswap V3 pool addresses.
 */
export const ZORA = {
  abi: erc20Abi,
  address: {
    [mainnet.id]: cleanAddress(zeroAddress),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0x1111111111166b7FE7bd91427724B487980aFc69'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress(zeroAddress),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress(zeroAddress),
    [arbitrum.id]: cleanAddress(zeroAddress),
  },
  poolAddress: UNISWAP_POOLS,
  name: 'Zora',
  symbol: 'ZORA',
  decimals: 18,
} as const satisfies ERC20Token
